import * as zod from 'zod';

export const MoveVerticalLiftVariables = zod.object({});

export type MoveVerticalLiftVariables = zod.infer<
  typeof MoveVerticalLiftVariables
>;
